module.exports = __webpack_public_path__ + "static/media/result_fg_id.fabd3a6b.jpg";